export const NO_ROLE = "none"
export const VIEWER_ROLE = "viewer"
export const ADMIN_ROLE = "admin"
